import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducers';
import { AppDispatch } from '../../store';
import { PostUI } from './PostUI';
import { request } from '../../Utils/request';
import { createHandlePress } from './PostCommonApi';
import BottomModal from '../../Components/BottomModel';
import Comments from './Comments';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TopNavBar from '../../Components/TopNavigation/TopNavBar';

const SavedPosts: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [savedPosts, setSavedPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [shareBottomModelOpen, setShareBottomModelOpen] = useState<boolean>(false);
  const [selectedPostId, setSelectedPostId] = useState<string>('');

  useEffect(() => {
    fetchSavedPosts();
  }, []);

  const fetchSavedPosts = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('Fetching saved posts from /profile/saved-posts');
      
      const response = await request<any>('/profile/saved-posts', {
        method: 'GET',
        authorization: true,
      });

      console.log('Saved posts response:', response);

      if (response?.success) {
        setSavedPosts(response.data || []);
      } else {
        setError(response?.message || 'Failed to fetch saved posts');
      }
    } catch (error: any) {
  
    } finally {
      setLoading(false);
    }
  };

  const handlePress = createHandlePress(
    dispatch,
    'image',
    setShareBottomModelOpen,
    setSelectedPostId
  );

  const ShareBottomModel = () => {
    return (
      <BottomModal
        open={shareBottomModelOpen}
        onClose={() => { setShareBottomModelOpen(false); setSelectedPostId(''); }}
        title="Comments"
        children={<Comments postId={selectedPostId} />}
      />
    );
  };

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          Loading saved posts...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
        <Button
          variant="contained"
          onClick={fetchSavedPosts}
          sx={{
            backgroundColor: '#F57C00',
            '&:hover': { backgroundColor: '#E65100' },
          }}
        >
          Try Again
        </Button>
      </Box>
    );
  }

  if (savedPosts.length === 0) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: 3,
        p: 3
      }}>
        <Typography variant="h5" color="text.secondary" textAlign="center">
          No Saved Posts
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Posts you bookmark will appear here
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/post')}
          sx={{
            backgroundColor: '#F57C00',
            '&:hover': { backgroundColor: '#E65100' },
          }}
        >
          Explore Posts
        </Button>
      </Box>
    );
  }

  return (
    <>
      <ShareBottomModel />
      <Box sx={{ p: 2 }}>
        {/* <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            onClick={() => navigate(-1)}
            sx={{ mr: 2, minWidth: 'auto' }}
          >
            ← Back
          </Button>
          <Typography variant="h5" fontWeight="bold">
            Saved Posts
          </Typography>
        </Box> */}
        <TopNavBar title='Saved Posts' canGoBack/>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {savedPosts.length} saved post{savedPosts.length !== 1 ? 's' : ''}
        </Typography>

        <Stack spacing={4}>
          {savedPosts.map((post, index) => (
            <Box key={post.id || index}>
              <PostUI
                item={post}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default SavedPosts;
